import { render, staticRenderFns } from "./alertIcon.vue?vue&type=template&id=67cb3450&scoped=true"
import script from "./alertIcon.vue?vue&type=script&lang=js"
export * from "./alertIcon.vue?vue&type=script&lang=js"
import style0 from "./alertIcon.vue?vue&type=style&index=0&id=67cb3450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cb3450",
  null
  
)

export default component.exports